import React from 'react';

function LoadingBubble() {
  return (
    <div className="flex justify-start mb-2">
      <div className="flex items-center justify-center">
        <div className="pulsate-animation w-4 h-4 rounded-full animate-pulse"></div>
      </div>
    </div>
  );
}

export default LoadingBubble;